import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import type { Job } from '@partiri-cloud/types';
import { WaitingListGuard } from '../waiting-list.guard';

/**
 * @file jobs.ts
 * Class for the jobs
 */
export class JobsApi {
  protected endpoint_services = '/jobs/services'
  protected endpoint_networking = '/jobs/networking'
  protected endpoint_resources = '/jobs/resources'

  constructor(private readonly http: HttpClient) { }

  /**
   * Get list of jobs
   */
  public list(id: string, options?: { limit: number; offset: number }): Observable<{ data: Job[], total: number }> {
    return this.http.get<{ data: Job[], total: number }>(`${this.endpoint_services}/${id}`, {
      params: options ? { limit: options.limit, offset: options.offset } : undefined,
    })
  }
  
  /**
   * Get single job for a service
   */
  public get(id: string): Observable<Job> {
    return this.http.get<Job>(`${this.endpoint_services}/${id}`)
  }
  
  /**
   * Get a single open job for a service
   */
  public getOpenServiceJob(): Observable<Job> {
    return this.http.get<Job>(`${this.endpoint_services}/open`)
  }

  /**
   * Deploy a specific service
   * @param apiKeyOptions 
   * @returns 
   */
  @WaitingListGuard()
  public deploy(id: string): Observable<Job> {
    return this.http.post<Job>(`${this.endpoint_services}/deploy/${id}`, {})
  }

  /**
   * Pause a running service
   * @param id
   * @returns
   */
  @WaitingListGuard()
  public pause(id: string): Observable<Job> {
    return this.http.post<Job>(`${this.endpoint_services}/pause/${id}`, {})
  }

  /**
   * Unpause a paused service
   * @param id
   * @returns
   */
  @WaitingListGuard()
  public unpause(id: string): Observable<Job> {
    return this.http.post<Job>(`${this.endpoint_services}/unpause/${id}`, {})
  }

  /**
   * Kill a running service
   * @param id
   * @returns
   */
  @WaitingListGuard()
  public kill(id: string): Observable<Job> {
    return this.http.post<Job>(`${this.endpoint_services}/kill/${id}`, {})
  }

  /**
   * Roll back a service to a previously succeeded deploy revision
   * @param serviceId
   * @param targetJobId
   * @returns
   */
  @WaitingListGuard()
  public rollback(serviceId: string, targetJobId: string): Observable<Job> {
    return this.http.post<Job>(`${this.endpoint_services}/rollback/${serviceId}`, { target_job_id: targetJobId })
  }
}
